module.exports = __webpack_public_path__ + "static/img/tuixiu.95daf1bd.png";